/** Compensa header fijo al hacer scroll a anclas (#contacto, etc.). */
const HASH_SCROLL_OFFSET_PX = 80;

export function scrollToHashTarget(
  hash?: string,
  behavior: ScrollBehavior = 'smooth',
): boolean {
  const id = (hash ?? window.location.hash).replace(/^#/, '').trim();
  if (!id) return false;

  const el = document.getElementById(id);
  if (!el) return false;

  const top = el.getBoundingClientRect().top + window.scrollY - HASH_SCROLL_OFFSET_PX;
  window.scrollTo({ top: Math.max(0, top), behavior });
  return true;
}

/** Reintenta hasta que React montó la sección (SPA + hash en URL directa). */
export function scrollToHashWhenReady(hash?: string): void {
  const behavior: ScrollBehavior = 'instant';

  const attempt = () => scrollToHashTarget(hash, behavior);

  if (attempt()) return;

  requestAnimationFrame(() => {
    if (attempt()) return;
    window.setTimeout(attempt, 50);
    window.setTimeout(attempt, 200);
    window.setTimeout(attempt, 500);
  });
}
